export default __webpack_public_path__ + "media/images/bullet-time-slot-ddaecf45e1f915a5c31f5f3cc38f480d.png";